<p>list-products-parent works!</p>
